import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full 
                 gradient-bg shadow-lg hover:shadow-primary/30 
                 flex items-center justify-center
                 transition-all duration-300 hover:scale-110
                 animate-fade-in"
      aria-label="Scroll to top"
    >
      <ArrowUp className="w-5 h-5 text-primary-foreground" />
    </button>
  );
};
